export const config = {
    schools: [
      {
          name: "UC Berkeley",
          lat: 37.87,
          long: -122.259,
          text: "Supports the proposed revisions but has concerns that the criteria and language of the guidelines may result in political consequences given critical race theory issues in public schools."
        },
      {
          name: "UC Davis",
          lat: 38.5382,
          long: -121.7617,
          text: "Supports the proposed revisions but would like to see less confrontational guidelines and has concerns about how students without access to a course to satisfy would meet the requirement."
        },
      {
          name: "UC Irvine",
          lat: 33.67,
          long: -117.838915,
          text: "Generally supports the proposed revisions but raises concerns about the quality of high school ethnic studies courses and how the guidelines align with the state’s goals."
      },
      {
          name: "UCLA",
          lat: 34.06999972,
          long: -118.4397899,
          text: "Majority supports the proposed revisions but suggests a first-year course option especially for international students and those from states that might explicitly restrict ethnic studies classes, as well as the possibility of the expectations being unrealistic."
        },
      {
          name: "UC Merced",
          lat: 37.366,
          long: -120.4235,
          text: "Mainly suggests clarifying guidelines and eliminating the “hierarchy of oppressions” in the description of what courses and subjects classify as ethnic studies."
        },
      {
          name: "UC Riverside",
          lat: 33.97205778,
          long: -117.3254087,
          text: "Supports the proposed revisions."
      },
      {
          name: "UCSD",
          lat: 32.87526317,
          long: -117.2361324,
          text: "Supports the proposed revisions but has concerns that some of the requirement language isolates community members in a way that leads to misrepresentation and suggests alternative descriptions while also questioning how the requirement will be put into practice.."
        },
      {
          name: "UC Santa Barbara",
          lat: 34.49,
          long: -119.75,
          text: "Supports the proposed revisions but raises questions about accessibility and implementation while also recommending working with K-12 districts to discuss a timeline."
        },
      {
          name: "UC Santa Cruz",
          lat: 37.1,
          long: -122.06,
          text: "Supports the proposed revisions but suggests further guidance from the UC to high schools and community colleges on the requirements and also raises the question of whether or not the UC Office of the President will need experts on ethnic studies for implementation."
      },
      {
          name: "UC San Francisco",
          lat: 37.75798863,
          long: -122.4551215,
          text: "Supports the proposed revisions but desires guidance and assistance to high schools for implementation as well as suggesting that local school boards give input on the proposal."
        }
    ]
  };